// extracted by css-extract-rspack-plugin
export default {"dropdown":"dropdown-FfM6LB","menuItem":"menuItem-sBabg8"};